import { render, staticRenderFns } from "./ObserveLayout.vue?vue&type=template&id=ed1ac3b0"
import script from "./ObserveLayout.vue?vue&type=script&lang=ts"
export * from "./ObserveLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports